import * as React from 'react';
import { useRouter } from 'next/router';
import { LoaderScreen } from '@grandvisionhq/common';
import { useDispatch } from '@grandvisionhq/state';
import { useSocialLoginMethod } from '../hooks/use-social-login-method.js';
import { loggedOut } from '../Logout/actions.js';
import { parseHash } from './actions.js';

const Callback = ({ type  })=>{
    const dispatch = useDispatch();
    const { asPath: callbackReturnPath , query  } = useRouter();
    const { handleSocialLogin  } = useSocialLoginMethod();
    React.useEffect(()=>{
        if (query.loginMethod === 'social') {
            handleSocialLogin();
        } else {
            if (type === 'callback') {
                dispatch(parseHash());
            }
            if (type === 'logged-out') {
                dispatch(loggedOut(callbackReturnPath));
            }
        }
    }, [
        callbackReturnPath,
        dispatch,
        handleSocialLogin,
        query.loginMethod,
        type
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LoaderScreen, {
        height: 50
    }));
};
var Callback$1 = Callback;

export { Callback$1 as default };
//# sourceMappingURL=Callback.js.map
